import { MenuItemOfBag } from '@app/contexts/Bag';
import { ComplementGroup, MenuItem } from '@app/types';
import { MenuItemWithDetailsOfBag } from '@app/types/menu-item';
import { getSelectedComplementMoreExpensive } from './menu';

export function calculateTotalItemPrice(item: MenuItem) {
  const complementsTotal = item.gruposDeComplementos.reduce((prev, group) => {
    return prev + calculateGroupPrice(group);
  }, 0);

  return item.preco + complementsTotal;
}

export function calculateTotalItemsPrice(items: MenuItemOfBag[] = []) {
  return items.reduce((prev, item) => {
    return prev + calculateTotalItemPrice(item) * (item.amount ?? 1);
  }, 0);
}

export function calculateGroupPrice(group: ComplementGroup) {
  if (shouldApplyCalculusByFlavourMoreExpensive(group)) {
    return calculateFlavoursGroupByMoreExpensive();
  }
  return calculateGroupByAmount();

  function calculateFlavoursGroupByMoreExpensive() {
    const flavourMoreExpensive = getSelectedComplementMoreExpensive(group.complementos || []);
    return flavourMoreExpensive?.preco ?? 0;
  }

  function calculateGroupByAmount() {
    return group.complementos.reduce((total, complement) => {
      return total + complement.preco * (complement.amount || 0);
    }, 0);
  }
}

export function shouldApplyCalculusByFlavourMoreExpensive(group: ComplementGroup) {
  return isComplementGroupOfFlavours() && group.precificaPeloMaisCaro && group.minimo > 1;

  function isComplementGroupOfFlavours() {
    return group.nome.toLowerCase().trim() === 'sabores' && group.minimo === group.maximo && group.opcional === false;
  }
}
